import {Component, Input, inject} from '@angular/core';
import { DxButtonModule, DxNumberBoxModule } from 'devextreme-angular';
import { FiltersGroupSettings } from '../models/filters-group-settings.model';
import { ContainerComponent } from 'src/app/components/container/container.component';
import { CoreService } from 'src/app/services/core.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { Filters } from '../types/filters.types';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
    selector: 'app-filters-group-settings-renderer',
    imports: [
        DxNumberBoxModule,
        DxButtonModule,
        ContainerComponent,
    ],
    templateUrl: './filters-group-settings-renderer.component.html',
    styleUrl: './filters-group-settings-renderer.component.scss',
	standalone: true
})
export class FiltersGroupSettingsRendererComponent {

	@Input()
	public filtersGroupsSettings: FiltersGroupSettings[];

	private _coreService: CoreService = inject(CoreService);
	private _localStorageService: LocalStorageService = inject(LocalStorageService);
	private _notificationService: NotificationService = inject(NotificationService);

	public onInvalidateButtonClicked(): void {
		for (let a = 0; a < this.filtersGroupsSettings.length; a++) {
			const filtersGroupSettings = this.filtersGroupsSettings[a];
			const localStorageKey = `${Filters.LocalStorageKeys.FiltersGroupSettingsPrefix}-route(${filtersGroupSettings.routeId})_operator(${filtersGroupSettings.filtersOperatorId})`;

			// Invalidate filters group settings cache for this route.
			this._localStorageService.remove(localStorageKey);
		}

		this._notificationService.success(
			"Filters Groups Settings cache invalidated."
		);
	}

	public onSaveSettingsButtonClicked(filtersGroupSettings: FiltersGroupSettings): void {
		this._coreService.updateFiltersGroupSettings(
			filtersGroupSettings,
			{
				showLoadingIndicator: true
			}
		).subscribe(
			{
				next: () => {
					const localStorageKey = `${Filters.LocalStorageKeys.FiltersGroupSettingsPrefix}-route(${filtersGroupSettings.routeId})_operator(${filtersGroupSettings.filtersOperatorId})`;

					// Update filters group settings cache for this route.
					this._localStorageService.set(localStorageKey, filtersGroupSettings);
				}
			}
		);
	}
}
